import { apiClient } from '@/api/client'
import { ApiError, parseProblemDetails } from '@/api/problemDetails'

import type { IntegrationConnector } from './types'

/**
 * O endpoint de listagem de integracoes (`GET /tenants/{tenantId}/integrations`) tem `.Produces<T>()`
 * no OpenAPI, entao `result.data` ja vem tipado pelo `openapi-fetch`. So resta o `undefined`
 * defensivo (a uniao de status codes do schema inclui respostas sem corpo tipado).
 */
function unexpectedFormatError(status: number): ApiError {
  return new ApiError({
    title: 'A resposta da Api nao tem o formato esperado.',
    status,
    errorCode: 'internal_error',
    correlationId: '',
  })
}

/**
 * Lista os conectores disponiveis para o tenant e, de cada um, a saude da integracao e as consultas
 * ao vivo (tools) que o agente pode fazer ao responder um cliente.
 */
export async function listIntegrations(tenantId: string): Promise<readonly IntegrationConnector[]> {
  const result = await apiClient.GET('/api/v1/tenants/{tenantId}/integrations', {
    params: { path: { tenantId } },
  })

  if (!result.response.ok) {
    throw new ApiError(parseProblemDetails(result.error, result.response.status))
  }

  if (result.data === undefined) {
    throw unexpectedFormatError(result.response.status)
  }

  return result.data
}
